import { render, staticRenderFns } from "./TwUserProfileLanguageDialog.vue?vue&type=template&id=3f7b2de2&"
import script from "./TwUserProfileLanguageDialog.vue?vue&type=script&lang=js&"
export * from "./TwUserProfileLanguageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports